import { useMutation, useQueryClient } from "react-query"
import { useApiClient } from "../../api-client/api-client.hooks"
import type { TApiGenericError } from "../../timenotes-query/timenotes-query.types"

interface Props {
  projectId: string
}

interface Args {
  taskId: string
  commentId: string
}

export function useDeleteCommentMutation(props: Props) {
  const {
    projectId
  } = props

  const apiClient = useApiClient()
  const queryClient = useQueryClient()

  const mutation = useMutation<{}, TApiGenericError<any>, Args>(
    ["delete-comment"],
    async (params: Args) => {
      const {
        taskId,
        commentId,
      } = params
      const response = await apiClient.deleteComment({
        projectId,
        taskId,
        commentId
      })

      if (!response.ok) {
        throw response.errors
      }

      return { response }
    },
    {
      onSuccess: (data, vars) => {
        queryClient.invalidateQueries(["project-task", projectId, vars.taskId], {
          exact: false,
        })
      }
    }
  )

  return mutation
}
